module.exports = __webpack_public_path__ + "media/newstyle/images/3000-outlets-aus-c455984467f72cdd341379072a317c15.svg";